<template lang="pug">
v-content: v-container
  v-card
    v-card-text(v-if="uid && edit")
      v-combobox(label="UID" v-model="edit.uid" disabled)
      v-combobox(label="Geräteart" v-model="edit.art" disabled)
      v-combobox(label="Hersteller" v-model="edit.hersteller" disabled)
      v-text-field(label="Model" v-model="edit.model" disabled)
      v-text-field(label="Seriennr." v-model="edit.seriennr" disabled)
      v-text-field(label="IMEI" v-model="edit.imei" disabled)
      v-combobox(label="Gekauft von Firma" v-model="edit.laden" disabled)
      input-date(label="Kaufdatum" v-model="edit.kaufdatum" disabled)
      v-combobox(label="Zustand" v-model="edit.zustand" disabled)

    v-data-table(:items="inventar" :headers="headers" v-else-if="isIt && !uid")
      template(slot="items" slot-scope="{item}")
        td: router-link(:to="`/inventar/${item.uid}`") {{item.uid}}
        td {{item.art}}
        td {{item.hersteller}}
        td {{item.model}}
        td {{item.seriennr}}
        td {{item.imei}}
        td {{item.laden}}
        td {{item.kaufdatum}}
        td {{item.zustand}}
    v-card-text(v-else-if="!$apollo.queries.inventar.loading && !$apollo.queries.currentUser.loading")
      | Hier gibt es nichts zu sehen

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      loading: 0,
      headers: [
        { text: "UID", value: "uid" },
        { text: "Geräteart", value: "art" },
        { text: "Hersteller", value: "hersteller" },
        { text: "Model", value: "model" },
        { text: "Seriennr", value: "seriennr" },
        { text: "IMEI", value: "imei" },
        { text: "Gekauft", value: "laden" },
        { text: "Kaufdatum", value: "kaufdatum" },
        { text: "Zustand", value: "zustand" },
      ],
    }
  },
  apollo: {
    inventar: {
      query() {
        return gql`query ExtraInventarVue($uid: String) {
          inventar(where: { uid: $uid }) {
            id
            uid
            art
            hersteller
            model
            seriennr
            imei
            laden
            kaufdatum
            zustand
          }
        }`
      },
      variables() {
        return { uid: this.uid }
      },
      skip() {
        return !this.isIt && !this.uid
      }
    },
    currentUser: {
      query: gql`query ExtraMeinProjektCurrentUser {
        currentUser {
          id
          rollen
        }
      }`
    },
  },
  computed: {
    uid() {
      return this.$route.params.uid
    },
    edit() {
      return this.inventar && this.inventar[0]
    },
    isIt() {
      const rollen = ["admin", "it"]
      const user = this.currentUser
      return !!(user && user.rollen && user.rollen.some((r) => rollen.indexOf(r) > -1))
    },
  },
}
</script>
